import React, { Fragment, useState } from 'react'
import { getCountryCodesForPhoneInput } from '@fielded/fs-api/lib/location/tools/location-locale'

import { Form, Page } from '@fielded/shared-ui'
import { toast } from '@fielded/shared-ui/src/components/Page'

import { isValidEmail, isValidCompletePhoneNumber } from '../../../../../van-shared/utils/utils'
import VerificationStatus from './VerificationStatus'
import VerificationModal from './VerificationModal'

export default (props) => {
  const {
    user,
    locationDisplayName,
    verificationLoading,
    onShowCancelChangesToast,
    onSendVerificationCode,
    onVerifyCode
  } = props

  const {
    fullName,
    email,
    phone,
    isEmailVerified,
    isPhoneVerified
  } = user.profile

  const [currentEmail, setCurrentEmail] = useState(email)
  const [currentPhone, setCurrentPhone] = useState(phone)
  const [verificationModal, setVerificationModal] = useState({
    isOpen: false,
    type: 'email'
  })

  const { name } = user
  const isFacilityLevel = user.location.level === 'sdp'

  const handleVerify = (method) => {
    const isValid = method === 'email'
      ? currentEmail && isValidEmail(currentEmail)
      : currentPhone && isValidCompletePhoneNumber(currentPhone)

    if (!isValid) {
      const message = method === 'email'
        ? 'Please provide a valid email address'
        : 'Please provide a valid phone number'

      toast({ title: message, type: 'warning' })
      return
    }

    setVerificationModal({ isOpen: true, type: method })
  }

  const handleCloseModal = () => {
    setVerificationModal({
      isOpen: false,
      type: 'email'
    })
  }

  const handleVerifyCode = async (method, code, contactInfo) => {
    try {
      await onVerifyCode(method, code, contactInfo)
      if (method === 'email') {
        setCurrentEmail(contactInfo)
      } else {
        setCurrentPhone(contactInfo)
      }
    } catch (error) {
      throw error
    }
  }

  const getContactInfo = () => {
    return verificationModal.type === 'email' ? currentEmail : currentPhone
  }

  return (
    <Fragment>
      <Page.Panel.Section title='General'>
        <Form.Row>
          <Form.Field
            labelText={`Display Name${isFacilityLevel ? ' / Facility name' : ''}`}
            fieldName='displayName'
          >
            <Form.Field.Text
              defaultValue={fullName}
              onValueChange={() => onShowCancelChangesToast()}
              required
            />
            <Form.Field.ValidationErrors />
          </Form.Field>
        </Form.Row>
        <Form.Row>
          <Form.Field labelText='Email' fieldName='email'>
            <Form.Field.Text
              defaultValue={email}
              onValueChange={(value) => {
                setCurrentEmail(value)
                onShowCancelChangesToast()
              }}
              required
            />
            <Form.Field.ValidationErrors />
            <VerificationStatus
              onVerify={() => handleVerify('email')}
              showVerify={(!isEmailVerified && currentEmail) || currentEmail !== email}
            />
          </Form.Field>
        </Form.Row>
        <Form.Row>
          <Form.Field labelText='Phone Number' fieldName='phoneNumber'>
            <Form.Field.PhoneInput
              defaultValue={phone}
              onValueChange={(value) => {
                setCurrentPhone(value)
                onShowCancelChangesToast()
              }}
              countryCodes={getCountryCodesForPhoneInput()}
            />

            {/* Ensure we account for country code selected */}
            <VerificationStatus
              onVerify={() => handleVerify('phone')}
              showVerify={(!isPhoneVerified && currentPhone && currentPhone.length > 4) || currentPhone !== phone}
            />
          </Form.Field>
        </Form.Row>
        <Form.Row>
          <Form.Field labelText='Username' fieldName='username'>
            <Form.Field.Text defaultValue={name} readOnly />
          </Form.Field>
        </Form.Row>
        <Form.Row>
          <Form.Field labelText='Location' fieldName='location'>
            <Form.Field.Text defaultValue={locationDisplayName} readOnly />
          </Form.Field>
        </Form.Row>
      </Page.Panel.Section>

      <VerificationModal
        isOpen={verificationModal.isOpen}
        isLoading={verificationLoading}
        verificationType={verificationModal.type}
        onClose={handleCloseModal}
        contactInfo={getContactInfo()}
        onSendCode={onSendVerificationCode}
        onVerifyCode={handleVerifyCode}
      />
    </Fragment>
  )
}
